import _asyncToGenerator from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import { axiosInstance } from 'boot/axios';

/**
 * Get basic info from the backend.
 * Version, maintenance mode...
 * @param dispatch
 * @param commit
 * @returns {*}
 */
export function check(_x) {
  return _check.apply(this, arguments);
}

/**
 * Change maintenance mode.
 * @param commit
 * @param {number|string} status | yes, no, in-progress
 */
function _check() {
  _check = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var dispatch, commit, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dispatch = _ref.dispatch, commit = _ref.commit;
          _context.next = 3;
          return axiosInstance.get('check');
        case 3:
          response = _context.sent;
          if (response) {
            commit('SET_CHECK', response.data);
          }
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _check.apply(this, arguments);
}
export function updateMaintenanceMode(_ref2, status) {
  var commit = _ref2.commit;
  commit('SET_CHECK', {
    maintenanceMode: status
  });
}